import styled from 'styled-components';

const media = {
  tablet: '@media(min-width: 768px)',
  desktop: '@media(min-width: 1366px)',
};

const SearchLoadsViewWrap = styled.div`
  margin: 0 auto;
  background: #1c2023;

  p {
    color: white;
  }

  .filter-wrapper {
    background: #1c2023;
    padding: 0 1px;
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    margin: -40px 0 -20px;
  }
  .filter-wrapper label {
    padding: 22px;
  }

  ${media.desktop} {
    width: 1340px;

    .filter-wrapper {
      width: 100%;
      background: #1c2023;
      padding: 0 1px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      margin: 0;
      text-align: center;
    }

    .filter-wrapper label {
      padding: 0 22px;
      width: 25pc;
    }

    .filter-wrapper input {
      border-radius: 20px;
    }
  }
`;

const LoadListWrap = styled.div`
  p {
    color: white;
  }

  p.loading-list {
    font-size: 14px;
    color: gray;
    margin-top: 45px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .loads-group-collapse {
    background: transparent;
  }

  .loads-group-collapse > .ant-collapse-item {
    border-bottom: 1px solid #4a5568;
    background: transparent;
  }

  .loads-group-collapse > .ant-collapse-item > .ant-collapse-header {
    color: #fff;
    font-weight: 400;
    padding: 10px 0;
  }

  .loads-group-collapse .ant-collapse-content {
    background: transparent;
    border-top: none;
    color: #fff;
  }

  .loads-group-collapse .ant-collapse-content-box {
    padding: 0 0 8px;
  }

  .loads-group-collapse .ant-collapse-arrow {
    color: #ffbb0f !important;
  }

  ${media.desktop} {
    display: inline-block;
    width: 70%;
    height: 100vh;
  }
`;

const TruckerListWrap = styled.div`
  p {
    color: white;
  }

  p.loading-list {
    font-size: 14px;
    color: gray;
    margin-top: 45px;
    text-align: center;
  }

  ${media.desktop} {
    display: inline-block;
    width: 70%;
    height: 100vh;
    overflow-y: hidden;
  }
`;

const MapWrap = styled.div`
  display: none;
  background: #30354e;
  height: 100vh;
  padding: 10px 30px;
  vertical-align: top;
  float: right;

  .leaflet-container {
    height: 23pc;
    width: 400px;
    margin: 0 auto;
    border-radius: 10px;
  }

  ${media.desktop} {
    display: inline-block;
    width: 30%;
    padding: 2px 10px;

    .leaflet-container {
      width: 100%;
    }

    h1 {
      color: white;
      text-align: center;
      margin-top: 10px;
      font-size: 30px;
    }
  }
`;

const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  padding: 12px 17px;
  background: #333750;

  ${media.desktop} {
    background: #1c2023;
    padding: 6px 17px;
  }

  .loads-search-input {
    flex: 1;
    min-width: 180px;
    height: 36px;
    padding: 0 14px;
    border-radius: 20px;
    border: 1px solid #4a5568;
    background: #2b333e;
    color: #fff;
    font-size: 14px;
    outline: none;
  }

  .loads-search-input::placeholder {
    color: #a0aec0;
  }

  .loads-search-input:hover {
    border-color: #ffbb0f;
  }

  .loads-search-input:focus {
    border-color: #ffbb0f;
    box-shadow: 0 0 0 1px #ffbb0f;
  }

  .group-by-select {
    width: 220px;
    min-width: 180px;
    margin-left: auto;
  }

  .group-by-select .group-by__control {
    background: #2b333e;
    border-color: #4a5568;
    min-height: 36px;
    box-shadow: none;
  }

  .group-by-select .group-by__control:hover {
    border-color: #ffbb0f;
  }

  .group-by-select .group-by__control--is-focused {
    border-color: #ffbb0f;
    box-shadow: 0 0 0 1px #ffbb0f;
  }

  .group-by-select .group-by__single-value,
  .group-by-select .group-by__placeholder,
  .group-by-select .group-by__input-container {
    color: #fff;
  }

  .group-by-select .group-by__placeholder {
    color: #a0aec0;
  }

  .group-by-select .group-by__indicator-separator {
    background: #4a5568;
  }

  .group-by-select .group-by__dropdown-indicator,
  .group-by-select .group-by__clear-indicator {
    color: #a0aec0;
  }

  .group-by-select .group-by__menu {
    background: #2b333e;
    color: #fff;
    z-index: 20;
  }

  .group-by-select .group-by__option {
    background: #2b333e;
    color: #fff;
  }

  .group-by-select .group-by__option--is-focused {
    background: #3a4452;
  }

  .group-by-select .group-by__option--is-selected {
    background: #ffbb0f;
    color: #1c2023;
  }
`;

const Title = styled.h1`
  flex: 1;
  min-width: 0;
  padding: 8px 0;
  margin: 0;
  color: white;
  font-size: 30px;
  text-align: center;
  background: transparent;

  ${media.desktop} {
    font-size: 26px;
    font-weight: 300;
    color: #ffbb0f;
    text-align: left;
    padding: 0;
  }
`;

const MapIconWrap = styled.div`
  span {
    color: black;
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background: #ffbb0f;
    float: right;
    text-align: center;
    margin: 10px 22px;
    padding: 2px;
  }
`;

const TodayLoadsWrapper = styled.div`
  width: 90%;
  overflow-x: auto;
  padding: 10px 0 0 10px;
  display: inline-block;

  h1 {
    margin: 0;
    color: #ffbb0f;
    width: 100%;
    font-weight: 400;
    text-align: left;
    font-size: 16px;
    border-bottom: unset;
    padding-bottom: 10px;
  }

  p {
    color: white;
  }

  ${media.desktop} {
    width: 98%;
    padding: 10px;
    margin: 10px 10px 0 10px;
    background: #2b333e;
    border-radius: 10px;
    min-height: 10pc;

    h1 {
      border-bottom: 1px solid gray;
    }

    p.empty-list {
      color: gray;
      width: 100%;
      text-align: center;
      margin-top: 33px;
    }
  }
`;

const TomorrowLoadsWrapper = styled.div`
  width: 90%;
  overflow-x: auto;
  padding: 10px 0 0 10px;
  display: inline-block;

  h1 {
    margin: 0;
    color: #ffbb0f;
    width: 100%;
    font-weight: 400;
    text-align: left;
    font-size: 16px;
    border-bottom: unset;
    padding-bottom: 10px;
  }

  p {
    color: white;
  }

  ${media.desktop} {
    width: 98%;
    padding: 10px;
    margin: 10px 10px 0 10px;
    background: #2b333e;
    border-radius: 10px;
    min-height: 10pc;

    h1 {
      border-bottom: 1px solid gray;
    }

    p.empty-list {
      color: gray;
      width: 100%;
      text-align: center;
      margin-top: 33px;
    }
  }
`;

const NextDaysLoadsWrapper = styled.div`
  width: 90%;
  overflow-x: auto;
  padding: 10px 0 0 10px;
  display: inline-block;
  margin-bottom: 10pc;

  h1 {
    margin: 0;
    color: #ffbb0f;
    width: 100%;
    font-weight: 400;
    text-align: left;
    font-size: 16px;
    border-bottom: unset;
    padding-bottom: 10px;
  }

  p {
    color: white;
  }
  ${media.desktop} {
    width: 98%;
    padding: 10px;
    margin: 10px 10px 0 10px;
    background: #2b333e;
    border-radius: 10px;
    min-height: 10pc;

    h1 {
      border-bottom: 1px solid gray;
    }

    p.empty-list {
      color: gray;
      width: 100%;
      text-align: center;
      margin-top: 33px;
    }
  }
`;

const LoadSelectedWrap = styled.div`
  background: #1c2023;
  h1 {
    color: #ffbb0f;
  }
`;

export default {
  SearchLoadsViewWrap,
  LoadListWrap,
  TruckerListWrap,
  MapWrap,
  TitleRow,
  Title,
  MapIconWrap,
  TodayLoadsWrapper,
  TomorrowLoadsWrapper,
  NextDaysLoadsWrapper,
  LoadSelectedWrap,
};
